module.exports = __webpack_public_path__ + "img/filter-purchase.e8c0f72f.svg";